// extracted by mini-css-extract-plugin
module.exports = {"loading-container":"Loader_loading-container__6UVPz"};